<form [formGroup]="form" novalidate>
    <div class="form-group"
     [class.error]="!allPassed"
     [class.row]="isRowStyle">
      <label 
        [class.col-sm-4]="isRowStyle"
        for="Password">
        <span translate>PASSWORD</span>
        <span class="required">*</span>
        <button 
          class="btn btn-link icon_eye" 
          type="button" 
          (click)="toggleShow()"
          [attr.aria-pressed]="showPassword"
          [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
          <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
      </label>
      <div 
        class="position-relative input-btn-group"
        [class.col-sm-6]="isRowStyle"        
        >
        <input
          #passwordInput
          id="Password"
          pInputText
          [type]="showPassword ? 'text' : 'password'"
          (focus)="togglePopover(true)"
          (blur)="togglePopover(false)"
          formControlName="password"
          (keydown.space)="$event.preventDefault()"
          (paste)="onPaste($event)"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
        />
       
        <button
            class="btn btn-link" 
            type="button" 
            style="margin-left: 5px;" 
            (click)="generateRandom()"
            aria-label="Auto-generate password"
        >
            <svg xmlns="http://www.w3.org/2000/svg" class="ic-sm" fill="var(--color-primary-500)" viewBox="0 0 512 512"><path d="M370.7 133.3C339.5 104 298.9 88 255.8 88c-77.5 .1-144.3 53.2-162.8 126.9-1.3 5.4-6.1 9.2-11.7 9.2H24.1c-7.5 0-13.2-6.8-11.8-14.2C33.9 94.9 134.8 8 256 8c66.4 0 126.8 26.1 171.3 68.7L463 41C478.1 25.9 504 36.6 504 57.9V192c0 13.3-10.7 24-24 24H345.9c-21.4 0-32.1-25.9-17-41l41.8-41.7zM32 296h134.1c21.4 0 32.1 25.9 17 41l-41.8 41.8c31.3 29.3 71.8 45.3 114.9 45.3 77.4-.1 144.3-53.1 162.8-126.8 1.3-5.4 6.1-9.2 11.7-9.2h57.3c7.5 0 13.2 6.8 11.8 14.2C478.1 417.1 377.2 504 256 504c-66.4 0-126.8-26.1-171.3-68.7L49 471C33.9 486.1 8 475.4 8 454.1V320c0-13.3 10.7-24 24-24z"/></svg>
        </button>
      </div>
    </div>
    <div class="form-group"
      [class.row]="isRowStyle"
      style="margin-bottom: 25px;" 
      [class.error]="!match"
      >
        <label 
          [class.col-sm-4]="isRowStyle" 
          for="confirmPassword">
            <span translate>CONFIRM_PASSWORD</span>
            <span class="required">*</span>
        </label>
        <div [class.col-sm-6]="isRowStyle">
            <input
                id="confirmPassword"
                pInputText
                type="{{ showPassword ? 'text' : 'password' }}"
                formControlName="confirmPassword"
                (keydown.space)="$event.preventDefault()"
                (paste)="onPaste($event)"
                autocorrect="off"
                autocapitalize="none"
                spellcheck="false"
            />
        </div>
    </div>
  </form>
  
  <div
  #popover
  class="popover bs-popover-right"
  [class.show]="popoverVisible"
>
  <div class="popover-body p-2 info-box" [class.error]="!allPassed">
    <ul class="mb-0 pl-2">
        <li *ngFor="let c of criteriaList">
            <span  *ngIf="c.passed" class="icon-checkmark icon icon_checkmark"></span>
            <svg *ngIf="!c.passed" class="icon icon_close" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>

            <span [class.passed]="c.passed" translate>{{ c.messageKey}}</span>
        </li>
    </ul>
  </div>
</div>